<template>
    <span :class="[`badge-indicator ${size}`, value < 0 ? 'decline' : 'profit']">
        <v-icon src="arrow-down" />
        <small>{{ value }}%</small>
    </span>
</template>

<script>
export default {
    name: "BadgeIndicator",
    props: {
        size: {
            type: String,
            default: () => ""
        },
        value: {
            default: 0
        }
    },
    methods: {}
};
</script>

<style lang="scss">
.badge-indicator {
    display: inline-flex;
    align-items: center;
    padding: 1px 8px;
    border-radius: 4px;
    cursor: default;
    &.decline {
        background: #f2cdcd;
        color: red;
        fill: red;
    }
    &.profit {
        fill: #0a9744;
        background: #dcf6e7;
        color: #0a9744;
        .svg-icon {
            transform: rotate(180deg);
        }
    }
    .svg-icon {
        font-size: 12px;
        padding: 2px;
        margin-right: 7px;
    }

    small {
        font-weight: 500;
        line-height: 22px;
    }

    &.sm {
        padding: 3px 8px;

        small {
            font-size: 12px;
            line-height: 14px;
        }

        .svg-icon {
            margin-right: 5px;
            font-size: 10px;
        }
    }

    &.lg {
        padding-top: 2px;
        padding-bottom: 2px;

        small {
            font-size: 16px;
            line-height: 24px;
        }

        .svg-icon {
            font-size: 14px;
            margin-right: 8px;
        }
    }
}
</style>
